import { siscomex } from './instance'

export const listRecintos = ({
  onError: emitErrorEvent = (e) => e,
  onSuccess: emitSuccessEvent = (e) => e
}) => {
  siscomex
    .get(
      `/consultas/recinto`
     
    )
    .then(({ data }) => emitSuccessEvent(data))
    .catch((error) => emitErrorEvent(error))
}